// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__q_lXr","notes":"Notes_notes__3uxX_"};